export default __webpack_public_path__ + "static/media/sticker-p.b1e7d317.png";